import { atom } from 'jotai';

/**
 * Jotai atoms for MFA SMS enrollment state management
 * Manages verification ID and phone number shared between phone input and code input components
 */
// Core MFA SMS state atoms
const mfaSmsVerificationIdAtom = atom(null);
const mfaSmsPhoneNumberAtom = atom('');
// Action atom to set both verification ID and phone number (when code is sent)
const setMfaSmsCodeSentAtom = atom(null, (_get, set, { verificationId, phoneNumber }) => {
    set(mfaSmsVerificationIdAtom, verificationId);
    set(mfaSmsPhoneNumberAtom, phoneNumber);
});
// Action atom to update verification ID (when code is resent)
const setMfaSmsVerificationIdAtom = atom(null, (_get, set, verificationId) => {
    set(mfaSmsVerificationIdAtom, verificationId);
});
// Action atom to clear MFA SMS state (when session expires or updating phone number)
const clearMfaSmsStateAtom = atom(null, (_get, set) => {
    set(mfaSmsVerificationIdAtom, null);
    set(mfaSmsPhoneNumberAtom, '');
});

export { clearMfaSmsStateAtom, mfaSmsPhoneNumberAtom, mfaSmsVerificationIdAtom, setMfaSmsCodeSentAtom, setMfaSmsVerificationIdAtom };
//# sourceMappingURL=mfaSmsAtoms.js.map
